<template>
    <div class="quotation-regular">
        <div v-if="loading">
            <v-skeleton-loader
                type="card-heading, list-item-three-line"
                class="mb-4"
            ></v-skeleton-loader>
            <v-skeleton-loader
                type="list-item-avatar-three-line, divider"
                class="mb-3"
            ></v-skeleton-loader>
            <v-skeleton-loader
                type="list-item-avatar-three-line, divider"
                class="mb-3"
            ></v-skeleton-loader>
            <v-skeleton-loader
                type="list-item-avatar-three-line, divider"
                class="mb-3"
            ></v-skeleton-loader>
        </div>
        <template v-for="(item, index) in orders">
            <div style="width: 100%" v-if="item.gridVersion == item.gri_version" :key="index">

                
                <div v-if="item.first" class="grid-row-template" style="font-size: .75em;
color: #707070;
font-weight: bold;">
                    <span>

                    </span>
                    <span>GRID</span>
                    <span class="d-flex align-center">
                        CLIENTE
                    </span>
                    <span>CNPJ</span>
                    <span>ITENS</span>
                    <span>DATA DO PEDIDO</span>
                    <span class="py-1">
                        EXECUTIVO
                    </span>
                </div>
                <v-card width="100%" v-if="item.first">
                    <div class="grid-row-template">
                        <span>
                            <v-btn icon to="/app/comercial/cotacoes/">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                            <v-divider vertical></v-divider>
                        </span>
                        <span>#{{ item.orderGridId }} (V.{{ item.gridVersion }})</span>
                        <span class="d-flex align-center">
                            <v-avatar class="mr-1"><img :src="item.pro_logo" alt="Logo cliente"></v-avatar>
                            <span>
                                <span>{{ item.pro_displayname || item.pro_name }}</span>
                                <v-btn color="success" small outlined :disabled="!item.accreditation_letter.length"
                                    :href="item.accreditation_letter && item.accreditation_letter.length ? item.accreditation_letter[0].url : 'javascript:void(0)'"
                                    target="_blank"><v-icon class="mr-1" small>mdi-download</v-icon> Carta de
                                    credenciamento</v-btn>
                            </span>
                        </span>
                        <span>{{ item.pro_document | document }}</span>
                        <span>{{ orders.length }}</span>
                        <span>{{ item.createdOn | dateTimeDefault }}</span>
                        <span class="py-1">
                            <v-card outlined class="pa-2 d-flex justify-space-between">{{ showAssociationText(item) ?
                                showAssociationText(item) : 'N/C' }}
                                
                                <v-btn icon @click="openAssociation(item)">
                                    <v-icon v-if="!showAssociationText">mdi-plus</v-icon>
                                    <v-icon v-if="showAssociationText">mdi-pencil</v-icon>
                                </v-btn>
                            </v-card>
                        </span>
                    </div>
                </v-card>
                <v-alert v-if="item.first && item.plannerMessage" type="info" text class="my-3">{{ item.plannerMessage }}</v-alert>

                <div class="padding: 5px">
                    <v-card class="pt-1">
                        
                        <v-alert color="blue" outlined :class="item.show ? 'my-1 mx-3' : 'mt-n1 mb-0'"
                            style="background: #fff !important">
                            <div class="black--text order-row-template pa-3">
                                <span>{{ index + 1 }}/{{ orders.length }}</span>
                                <span v-if="item.itemType === 'formato'">
                                    <div>Formato: {{ item.asuFormat?.asus?.format | asuFormat }}</div>
                                    <div v-if="item.ssuOrders && item.ssuOrders.length" class="text-caption"
                                        style="color: #4CAF50; margin-top: 4px;">
                                        <v-icon small color="success">mdi-plus-circle</v-icon> serviço complementar
                                    </div>
                                </span>
                                <span v-if="item.itemType === 'servico'">Serviço: {{ getServiceType(item) }}</span>
                                <span>
                                    <v-chip round :color="getStatusColor(item)" :dark="false" class="black--text">{{ getStatusText(item) }}</v-chip>
                                </span>
                                <span>Negociação: {{ getLastQuotationStatus(item, 'quotation') }}</span>
                                <span>{{ getLastQuotationStatus(item, 'date') }}</span>
                                <span>{{ getLastQuotationStatus(item, 'email') }}</span>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-bind="attrs" v-on="!hasExecutive(item) ? on : {}">
                                            <v-btn icon @click="toggleItemShow(item)" :disabled="!hasExecutive(item)">
                                                <v-icon v-if="!item.show">mdi-chevron-down</v-icon>
                                                <v-icon v-if="item.show">mdi-chevron-up</v-icon>
                                            </v-btn>
                                        </div>
                                    </template>
                                    <span>É necessário atribuir um executivo para esta cotação antes de visualizar os
                                        detalhes</span>
                                </v-tooltip>
                            </div>
                        </v-alert>
                        <div v-if="item.show" class="mt-3 px-3 pb-6">
                            
                            <template v-if="item.itemType === 'formato'">
                                
                                <v-row class="mt-3">
                                    <v-col cols="12" md="5" sm="12">
                                        <v-alert class="pa-3" outlined color="blue">
                                            <table width="100%" class="black--text">
                                                <tr>
                                                    <th width="35%" align="right">Inventário:</th>
                                                    <td class="d-flex">{{ item.asuFormat.display_name }}
                                                        <v-spacer></v-spacer><v-btn style="margin-bottom: -20px"
                                                            @click="openInfo(item)" color="info" outlined>Detalhes do
                                                            formato</v-btn>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Formato:</th>
                                                    <td>{{ item.asuFormat.asus.format | asuFormat }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Código:</th>
                                                    <td>{{ (item?.asuFormat?.asus?.asu_client_id != null ?
                                                        item.asuFormat.asus.asu_client_id : 'N/C') }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Detalhes:</th>
                                                    <td>{{ item.asuFormat.asus.bucket | asuBuckets }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Localização:</th>
                                                    <td>
                                                        <span
                                                            v-if="item.asuFormat.asus?.locations && item.asuFormat.asus.locations.length">{{
                                                                item.asuFormat.asus.locations[0] | location }}</span>
                                                        <span
                                                            v-if="item.asuFormat.asus?.locations && item.asuFormat.asus.locations.length && item.asuFormat.asus.locations.length > 1"
                                                            v-html="$tc('common.location', item.asuFormat.asus.locations.length - 1, { count: item.asuFormat.asus.locations.length - 1 })"
                                                            class="ml-1"></span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-alert>

                                        <v-alert class="pa-3" outlined color="blue">
                                            <table width="100%" class="black--text">
                                                <tr>
                                                    <th width="35%" align="right">Valor tabela bruto unit.:</th>
                                                    <td class="d-flex">{{
                                                        $n(item.newPriceTable != null
                                                            ? item.newPriceTable
                                                            : item.asuFormat.asus.private_pricing_info.markup
                                                            * item.asuFormat.asus.private_pricing_info.unity_price,
                                                        'currency') }}
                                                        {{ item.asuFormat.asus?.custom_messages?.msg_unit_price }}
                                                        <v-spacer></v-spacer>
                                                        <v-btn style="margin-bottom: -20px" color="orange"
                                                            @click="openPrice(item)" :disabled="!isExecutive(item)"
                                                            outlined>Corrigir preço</v-btn>
                                                    </td>
                                                </tr>
                                                <tr v-if="item.asuLastUpdate">
                                                    <td></td>
                                                    <td
                                                        style="margin-top: 0; padding-top: 0; line-height: 0; font-style: italic">
                                                        Última atualização: {{ item.asuLastUpdate | date }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Desconto inicial cadastrado:</th>
                                                    <td>{{ $n(item.asuFormat.asus.private_pricing_info.markup *
                                                        item.asuFormat.asus.private_pricing_info.unity_price *
                                                        (item.asuFormat.asus.private_pricing_info.discount > 0 ?
                                                            item.asuFormat.asus.private_pricing_info.discount / 100 : 0),
                                                        'currency') }} ({{
                                                            $n(item.asuFormat.asus.private_pricing_info.discount) }}%)</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Período unitário:</th>
                                                    <td>{{ item.asuFormat.asus.periodicity | asuPeriodicity }}</td>
                                                </tr>

                                            </table>
                                        </v-alert>
                                    </v-col>
                                    <v-col cols="12" md="7" sm="12">
                                        <h4 class="primary--color"><v-icon>mdi-calendar</v-icon> Cronograma do plano
                                        </h4>
                                        <v-card class="mt-2" style="overflow-x: auto;">
                                            <table class="calendar-table" striped>
                                                <thead>
                                                    <tr>
                                                        <th bgcolor="#fff"></th>
                                                        <th v-for="d in 31" :key="`${index}-${d}`">{{ d }}</th>
                                                    </tr>
                                                </thead>
                                                <QuotationCalendarPeriods :order="item"
                                                    @update-totalizers="setComputedTotals(index, $event)">
                                                </QuotationCalendarPeriods>
                                            </table>
                                        </v-card>
                                        <div class="d-flex pt-1">
                                            <v-spacer></v-spacer>
                                            <v-btn disabled small color="primary" class="mt-1">Sugerir alteração de
                                                cronograma <v-chip color="light-blue lighten-3" text-color="white"
                                                    x-small class="ml-2">
                                                    Em breve
                                                </v-chip></v-btn>
                                        </div>

                                        <QuotationTrading :quotation-status-range="quotationStatusRange" :item="item"
                                            :computed-totals="computedTotals[index]" :is-executive="isExecutive(item)"
                                            @response-quotation="load()"
                                            @accepted-quotation="showSuccessBanner()">
                                        </QuotationTrading>

                                    </v-col>
                                </v-row>
                            </template>

                            
                            <template v-if="item.itemType === 'servico'">
                                <v-row class="mt-3">
                                    
                                    <v-col cols="12" md="6" sm="12">
                                        <v-alert class="pa-3" outlined color="blue">
                                            <table width="100%" class="black--text">
                                                <tr>
                                                    <th width="35%" align="right">Serviço complementar:</th>
                                                    <td>{{ item.snap?.name || 'N/D' }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Tipo de serviço:</th>
                                                    <td>{{ getServiceType(item) }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Código de referência:</th>
                                                    <td>{{ item.snap?.providerProductCode || 'N/D' }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Descrição:</th>
                                                    <td v-html="item.snap?.description || 'N/D'"></td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Especificações:</th>
                                                    <td v-html="item.snap?.specifications || 'N/D'"></td>
                                                </tr>
                                                <tr v-if="item.snap?.general_policies?.booking_days?.installation?.value">
                                                    <th align="right">Tempo de instalação:</th>
                                                    <td>{{
                                                        item.snap?.general_policies?.booking_days?.installation?.value
                                                        }} {{
                                                            item.snap?.general_policies?.booking_days?.installation?.type ||
                                                        '' }}</td>
                                                </tr>
                                                <tr v-if="item.snap?.general_policies?.booking_days?.production?.value">
                                                    <th align="right">Prazo de entrega:</th>
                                                    <td>{{ item.snap?.general_policies?.booking_days?.production?.value
                                                        }} {{
                                                            item.snap?.general_policies?.booking_days?.production?.type ||
                                                        '' }}</td>
                                                </tr>
                                                <tr v-if="item.snap?.general_policies?.booking_days?.duration?.value">
                                                    <th align="right">Tempo de produção:</th>
                                                    <td>{{ item.snap?.general_policies?.booking_days?.duration?.value }} {{
                                                            item.snap?.general_policies?.booking_days?.duration?.type || ''
                                                        }}</td>
                                                </tr>
                                                <tr v-if="item.snap?.general_policies?.booking_days?.durability?.value">
                                                    <th align="right">Durabilidade prevista:</th>
                                                    <td>{{ item.snap?.general_policies?.booking_days?.durability?.value
                                                        }} {{
                                                            item.snap?.general_policies?.booking_days?.durability?.type ||
                                                        '' }}</td>
                                                </tr>
                                            </table>
                                        </v-alert>
                                    </v-col>

                                    
                                    <v-col cols="12" md="6" sm="12">
                                        <h4 class="primary--color mb-3"><v-icon>mdi-calendar</v-icon> Cronograma do
                                            plano</h4>

                                        <v-card outlined>
                                            <table width="100%" class="pa-3">
                                                <tr>
                                                    <th width="50%" align="right">Data de início da veiculação da mídia:
                                                    </th>
                                                    <td>{{ item.dates && item.dates.length ?
                                                        formatServiceDate(item.dates[0].date) : 'N/D' }}</td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Formato da mídia:</th>
                                                    <td>{{ item.parentFormat?.display_name || item.parentFormat?.uri ||
                                                        'N/D' }} — {{ item.parentFormat?.format || 'N/D' }}</td>
                                                </tr>
                                            </table>
                                        </v-card>

                                        <v-card outlined class="mt-3 pa-3">
                                            <table width="100%">
                                                <tr>
                                                    <th width="30%" align="right">Valor base:</th>
                                                    <td>{{ $n(item.unityTablePrice || 0, 'currency') }} {{ item.snap?.pricing_policy?.label || '' }}</td>
                                                    <th width="30%"></th>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="item.base?.multiple">
                                                    <th align="right">Múltiplo:</th>
                                                    <td>{{ item.base.multiple }}</td>
                                                    <th></th>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Valor unitário:</th>
                                                    <td>{{ $n(item.unityPrice || 0, 'currency') }}</td>
                                                    <th></th>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Quantidade final:</th>
                                                    <td>{{ item.totalQuantity || 0 }}</td>
                                                    <th></th>
                                                    <td></td>
                                                </tr>
                                                <tr
                                                    style="border-top: 1px solid #2196F3; border-bottom: 1px solid #2196F3;">
                                                    <th align="right">Aplicar desconto:</th>
                                                    <td colspan="3">
                                                        <div class="d-flex align-center outlined">
                                                            <v-text-field :disabled="item.expired === true || !isExecutive(item) || (DEBUG_MODE_ENABLE_BUTTONS ? false : (item.status === 18 || item.status === 13))" class="mt-8"
                                                                v-model="item.serviceDiscount"
                                                                @input="calculateServiceDiscount(item)" outlined rounded
                                                                label="Percentual" append-icon="mdi-percent-outline"
                                                                v-show="!item.serviceInvert"
                                                                color="primary"></v-text-field>
                                                            <v-text-field :disabled="item.expired === true || !isExecutive(item) || (DEBUG_MODE_ENABLE_BUTTONS ? false : (item.status === 18 || item.status === 13))" class="mt-8"
                                                                v-model="item.serviceFixedValue"
                                                                @input="calculateServiceDiscount(item)" outlined rounded
                                                                label="Valor" prepend-inner-icon="mdi-currency-brl"
                                                                v-show="item.serviceInvert"
                                                                color="primary"></v-text-field>

                                                            <v-btn icon :disabled="item.expired === true || !isExecutive(item) || (DEBUG_MODE_ENABLE_BUTTONS ? false : (item.status === 18 || item.status === 13))" class="mx-1"
                                                                @click="item.serviceInvert = !item.serviceInvert">
                                                                <v-icon>mdi-swap-horizontal</v-icon>
                                                            </v-btn>

                                                            <v-text-field type="number" disabled hide-details
                                                                v-show="item.serviceInvert" color="primary"
                                                                v-model="item.serviceDiscount" outlined rounded
                                                                label="Percentual"
                                                                append-icon="mdi-percent-outline"></v-text-field>
                                                            <v-text-field disabled hide-details
                                                                v-show="!item.serviceInvert" color="primary"
                                                                v-model="item.serviceFixedValue" outlined rounded
                                                                label="Valor"
                                                                prepend-inner-icon="mdi-currency-brl"></v-text-field>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Status do serviço:</th>
                                                    <td colspan="3">
                                                        <v-chip :color="getStatusColor(item)" :dark="false" class="black--text" small>
                                                            {{ getStatusText(item) }}
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Valor s/ desconto:</th>
                                                    <td>{{ $n(item.netUnitPrice || 0, 'currency') }}</td>
                                                    <th></th>
                                                    <td>
                                                        <v-tooltip bottom :disabled="item.expired !== true && item.status !== 18 && item.status !== 13">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn 
                                                                        :disabled="item.expired === true || !isExecutive(item) || (DEBUG_MODE_ENABLE_BUTTONS ? false : (item.status === 18 || item.status === 13))" 
                                                                        @click="openServiceAccept(item)"
                                                                        rounded 
                                                                        block 
                                                                        small
                                                                        color="success" 
                                                                        elevation="0"
                                                                    >
                                                                        Salvar e enviar <v-icon small right>mdi-send-variant</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <span v-if="item.expired === true">Esta cotação foi cancelada por falta de resposta</span>
                                                            <span v-else-if="item.status === 18">Este serviço está aguardando aprovação</span>
                                                            <span v-else-if="item.status === 13">Este serviço foi cancelado</span>
                                                        </v-tooltip>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th align="right">Valor negociado:</th>
                                                    <td>{{ $n(item.serviceFinalPrice || 0, 'currency') }}</td>
                                                    <th></th>
                                                    <td>
                                                        <v-tooltip bottom :disabled="item.expired !== true && item.status !== 18 && item.status !== 13">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <div v-bind="attrs" v-on="on">
                                                                    <v-btn 
                                                                        :disabled="item.expired === true || !isExecutive(item) || (DEBUG_MODE_ENABLE_BUTTONS ? false : (item.status === 18 || item.status === 13))" 
                                                                        @click="openServiceCancel(item)"
                                                                        rounded 
                                                                        block 
                                                                        outlined
                                                                        color="error" 
                                                                        small
                                                                    >
                                                                        Reprovar cotação <v-icon small right>mdi-cancel</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </template>
                                                            <span v-if="item.expired === true">Esta cotação foi cancelada por falta de resposta</span>
                                                            <span v-else-if="item.status === 18">Este serviço está aguardando aprovação</span>
                                                            <span v-else-if="item.status === 13">Este serviço foi cancelado</span>
                                                        </v-tooltip>
                                                    </td>
                                                </tr>
                                            </table>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </template>
                        </div>
                    </v-card>
                    
                </div>
            </div>

        </template>
        <v-dialog v-model="asu.show" max-width="1366">
            <asu-info v-if="asu.show" :item="asu.data.asuFormat" :info="asuInfo"></asu-info>
        </v-dialog>
        <v-dialog v-model="updatePrice.show" max-width="768">
            <asu-update-price v-if="updatePrice.show" @close-dialog="updatePrice.show = $event"
                @price-updated="load()"
                :request="updatePrice.data"></asu-update-price>
        </v-dialog>

        <v-dialog v-model="gridExecutiveAssociation.show" max-width="900" persistent>
            <grid-association-executive v-if="gridExecutiveAssociation.show" @close-dialog="onCloseAssociation"
                :users="gridExecutiveAssociation.data.users"
                :grid="gridExecutiveAssociation.data"></grid-association-executive>
        </v-dialog>

        
        <v-dialog v-model="serviceAccept.show" max-width="800">
            <v-card v-if="serviceAccept.show && serviceAccept.item">
                <v-card-title>Confirme a negociação para prosseguir:</v-card-title>
                <v-card-text>
                    <h4 class="blue--text mt-0 mb-2">
                        Cliente {{ serviceAccept.item.pro_displayname || serviceAccept.item.pro_name }} - 
                        {{ serviceAccept.item.pro_document | document }}
                    </h4>
                    <div class="d-flex align-end justify-space-between">
                        <ul style="flex: 1;">
                            <li><strong>Serviço complementar:</strong> {{ serviceAccept.item.snap?.name || 'NOME DO SERVIÇO' }}</li>
                            <li><strong>Tipo de serviço:</strong> {{ getServiceType(serviceAccept.item) }}</li>
                            <li><strong>Data de início da veiculação da mídia:</strong> {{ serviceAccept.item.dates && serviceAccept.item.dates.length ? (serviceAccept.item.dates[0].startPlacement | date) : 'Data início do formato associado' }}</li>
                            <li><strong>Formato da mídia:</strong> {{ serviceAccept.item.parentFormat?.display_name || serviceAccept.item.parentFormat?.uri || 'Inventário' }} — {{ serviceAccept.item.parentFormat?.format || 'Nome do Formato (ASU)' }}</li>
                            <li><strong>Valor unitário:</strong> {{ $n(serviceAccept.item.netUnitPrice || 0, 'currency') }} {{ serviceAccept.item.snap?.pricing_policy?.label || '' }}</li>
                            <li><strong>Quantidade do pedido:</strong> {{ serviceAccept.item.totalQuantity || 0 }}</li>
                            <li><strong>Desconto:</strong> {{ parseFloat(serviceAccept.item.serviceDiscount) > 0 ? serviceAccept.item.serviceDiscount + '%' : '0%' }}</li>
                            <li style="font-size: 1.2em; color: #000; font-weight: bold"><strong>Valor líquido final:</strong> {{ $n(serviceAccept.item.serviceFinalPrice * 0.8 || 0, 'currency') }} (80%)</li>
                        </ul>
                        <div style="flex: 0 0 280px; margin-left: 5px;">
                            <v-textarea
                                v-model="serviceAccept.observation"
                                outlined
                                dense
                                rows="3"
                                hide-details
                                placeholder="Observação (opcional)"
                                class="mb-3"
                            ></v-textarea>
                            <v-btn 
                                block 
                                color="success" 
                                elevation="0" 
                                class="mb-1 mx-0" 
                                x-large 
                                @click="saveService('accept')" 
                                :loading="serviceAccept.loading"
                            >
                                Aplicar condição
                            </v-btn>
                            <v-btn 
                                block 
                                outlined 
                                color="error" 
                                small 
                                @click="serviceAccept.show = false"
                                class="mx-0"
                            >
                                Cancelar
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        
        <v-dialog v-model="serviceCancel.show" max-width="768">
            <v-card v-if="serviceCancel.show && serviceCancel.item">
                <v-card-title>Cancelar serviço complementar</v-card-title>
                <v-card-text>
                    <v-alert type="warning">
                        <p>Ao cancelar este serviço complementar, você encerra a negociação deste item.</p>
                        <p>O serviço será removido da cotação atual.</p>
                    </v-alert>
                    <p><strong>Serviço:</strong> {{ serviceCancel.item.snap?.name || 'N/D' }}</p>
                    <p>Por favor, descreva em poucas palavras o motivo da recusa.</p>
                    <v-textarea v-model="serviceCancel.reason" label="Motivo" outlined></v-textarea>

                    <div class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn text @click="serviceCancel.show = false">Voltar</v-btn>
                        <v-btn 
                            color="error" 
                            @click="saveService('cancel')" 
                            :loading="serviceCancel.loading"
                        >
                            Cancelar serviço
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="successBanner.show" max-width="560" overlay-color="rgba(0,0,0,0.25)" content-class="success-banner-dialog">
            <v-card class="success-banner-card" style="background: #439463; border-radius: 20px; color: #fff; padding: 28px 24px 24px; box-shadow: none !important;">
                <v-btn icon absolute top right style="color:#fff; top:8px; right:8px; background:transparent !important;" @click="successBanner.show = false" plain>
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>

                <div class="success-banner-title">{{ successBanner.fullName }},</div>

                <p class="success-banner-text">
                    Agora que você já respondeu a essa cotação, que tal
                    <span class="success-banner-highlight">agilizar as próximas?</span>
                </p>

                <p class="success-banner-text">
                    Garanta que seus <strong>dados</strong> estejam
                    <strong>completos e atualizados:</strong> formatos, dados bancários, preços, descontos etc.
                </p>

                <p class="success-banner-text">
                    Ah, não esqueça de incluir informação sobre sua <strong>audiência</strong>, muitas vezes é decisivo na tomada de decisão dos anunciantes e agências.
                </p>

                <div class="success-banner-buttons">
                    <v-btn
                        block
                        depressed
                        dark
                        rounded
                        style="background:#061556; max-width:420px; font-weight:700;"
                        class="mb-3"
                        href="/app/inventory/formats">
                        Atualizar preços →
                    </v-btn>
                    <v-btn
                        block
                        outlined
                        dark
                        rounded
                        style="max-width:420px; border-color:#fff; font-weight:700;"
                        href="/app/management/profiles">
                        Ver dados cadastrais →
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import QuotationCalendarPeriods from '@/components/quotation/QuotationCalendarPeriods.vue';
import QuotationTrading from '@/components/quotation/QuotationTrading.vue';
import AsuInfo from '@/interface/AsuInfo.vue'
import AsuUpdatePrice from '@/components/quotation/AsuUpdatePrice.vue'
import GridAssociationExecutive from '@/components/quotation/GridAssociationExecutive.vue'
import moment from 'moment'
import helper from '@/plugins/helper'
import { showSuccess, showError, showInfo } from '@/plugins/snackbar-helper'
export default {
    name: "QuotationRegularView",
    components: {
        QuotationCalendarPeriods,
        QuotationTrading,
        AsuUpdatePrice,
        AsuInfo,
        GridAssociationExecutive
    },
    data: () => ({
        DEBUG_MODE_ENABLE_BUTTONS: false,
        
        asu: {
            data: null,
            show: false
        },
        updatePrice: {
            data: null,
            show: false
        },
        gridExecutiveAssociation: {
            data: null,
            show: false
        },
        serviceAccept: {
            show: false,
            loading: false,
            item: null,
            observation: ''
        },
        serviceCancel: {
            show: false,
            loading: false,
            item: null,
            reason: '',
            text: ''
        },
        successBanner: {
            show: false,
            fullName: '',
            pending: false
        },
        loading: true,
        orders: [],
        computedTotals: {},
        quotationStatusRange: ['15', '16', '17']

    }),
    watch: {
            orders: {
                deep: true,
                handler(orders) {
                    
                    orders.forEach(order => {
                        if (order.itemType === 'servico') {
                            this.calculateServiceDiscount(order)
                        }
                    })
                }
            }
        },
        computed: {

            // Monta o objeto de "detalhes do formato" exibido no cabeçalho do AsuInfo
            // (título, faixa horária, localidade e buckets), a partir do asuFormat da cotação.
            asuInfo() {
                const asuFormat = this.asu.data && this.asu.data.asuFormat
                if (!asuFormat || !asuFormat.asus) return {}
                const asus = asuFormat.asus

                let title = ''
                if (asus.format) {
                    const format = asus.format
                    title = (format.print || 'type value metric')
                        .replace('type', format.type)
                        .replace('value', format.value)
                        .replace('metric', format.metric)
                }

                // Faixa horária (ex: "Indeterminado das 07:00 às 19:00")
                let timeslot = ''
                const timeZones = (asus.booking_policy && asus.booking_policy.time_zone) || []
                const slots = timeZones.map((tz) => {
                    let text = tz.type ? `<strong>${tz.type}</strong>` : ''
                    const min = this.formatDaySeconds(tz.min)
                    const max = this.formatDaySeconds(tz.max)
                    if (min && max) text += ` das ${min} às ${max}`
                    else {
                        if (min) text += ` a partir das ${min}`
                        if (max) text += ` até as ${max}`
                    }
                    return text.trim()
                }).filter(Boolean)
                if (slots.length) timeslot = slots.join(', ')

                // Localidade
                let location = ''
                const locations = asus.locations || []
                if (locations.length) {
                    let loc = this.$options.filters.location(locations[0]) || ''
                    if (Array.isArray(loc)) loc = loc.join(', ')
                    location = loc
                    if (locations.length > 1) location += ` + ${locations.length - 1}`
                }

                let bucket = ''
                if (asus.bucket && asus.bucket.length) {
                    bucket = this.$options.filters.asuBuckets(asus.bucket)
                }

                return { title, timeslot, location, bucket }
            },

            getFilteredSsuOrders() {
                return (item) => {
                    if (!item || !item.ssuOrders || !item.pro_id) return []

                    return item.ssuOrders.filter(ssuOrder => {
                        return ssuOrder.providerData &&
                            ssuOrder.providerData.profileId &&
                            String(ssuOrder.providerData.profileId) === String(item.pro_id)
                    })
                }
            }
        },
        mounted() {
            this.load()
        },
        methods: {

            // Converte segundos a partir da meia-noite (formato usado nas faixas
            // horárias do portal) para "HH:mm". Aceita também valores já formatados.
            formatDaySeconds(value) {
                if (value === null || value === undefined || value === '') return ''
                if (typeof value === 'number') {
                    return moment().startOf('day').add(value, 'seconds').format('HH:mm')
                }
                return value
            },

            getMatchingSsuOrders(item) {
                if (!item || !item.ssuOrders || !item.pro_id) return []

                return item.ssuOrders.filter(ssuOrder => {
                    return ssuOrder.providerData &&
                        ssuOrder.providerData.profileId &&
                        String(ssuOrder.providerData.profileId) === String(item.pro_id)
                })
            },
            
            getItemTitle(item) {
                if (item.itemType === 'servico') {
                    return item.snap?.name || 'Serviço'
                }
                return item.asuFormat?.asus?.format || 'Formato'
            },
            
            getServiceType(item) {
                if (item.itemType !== 'servico') return ''

                const typeMap = {
                    'creation': 'Criação',
                    'production_installation_and_removal': 'Produção/Instalação/Remoção',
                    'production': 'Produção',
                    'installation': 'Instalação',
                    'removal': 'Remoção'
                }

                return typeMap[item.type] || item.type || 'N/D'
            },
            
            calculateServiceDiscount(item) {
                if (item.itemType !== 'servico') return

                const basePrice = item.netUnitPrice || 0

                if (!item.serviceInvert) {
                    
                    const discount = parseFloat(item.serviceDiscount) || 0
                    const discountValue = basePrice * (discount / 100)
                    item.serviceFixedValue = discountValue.toFixed(2)
                    item.serviceFinalPrice = basePrice - discountValue
                } else {
                    
                    const fixedValue = parseFloat(item.serviceFixedValue) || 0
                    const discountPercent = (fixedValue / basePrice) * 100
                    item.serviceDiscount = discountPercent.toFixed(2)
                    item.serviceFinalPrice = basePrice - fixedValue
                }
            },
            hasExecutive(item) {
                if (!item || !item.users || !item.users.length) return false
                return item.users.some(user => user.isExecutiveFromGrid)
            },
            isExecutive(item) {
                if (!item || !item.users || !item.users.length || !this.$root.auth || !this.$root.auth.user) return false
                const loggedUserId = this.$root.auth.user.uid
                return item.users.some(user => user.isExecutiveFromGrid && user.id === loggedUserId)
            },
            toggleItemShow(item) {
                if (!this.hasExecutive(item)) {
                    return
                }
                item.show = !item.show
            },
            setComputedTotals(index, totals) {
                this.$set(this.computedTotals, index, totals)
            },
            showAssociationText(item) {
                const users = item.users
                const associated = {}
                users.forEach((user) => {
                    if (user.isExecutiveFromGrid && !associated.hasOwnProperty(user.id)) {
                        associated[user.id] = user
                    }
                })
                const result = []
                Object.values(associated).forEach((item) => {
                    result.push(`${item.name} <${item.email}>`)
                })

                if (result.length)
                    return result.join(', ')
                else
                    return null


            },
            openAssociation(item) {
                this.gridExecutiveAssociation.data = item
                this.gridExecutiveAssociation.show = true
            },
            onCloseAssociation(shouldClose) {
                this.gridExecutiveAssociation.show = shouldClose
                if (!shouldClose) {
                    
                    this.load()
                }
            },
            openInfo(item) {
                this.asu.data = item
                this.asu.show = true
            },
            openPrice(item) {
                this.updatePrice.data = item
                this.updatePrice.show = true
            },
            openServiceAccept(item) {
                this.serviceAccept.item = item
                this.serviceAccept.observation = ''
                this.serviceAccept.show = true
            },
            openServiceCancel(item) {
                this.serviceCancel.item = item
                this.serviceCancel.reason = ''
                this.serviceCancel.text = ''
                this.serviceCancel.show = true
            },
            saveService(action) {
                const item = action === 'accept' ? this.serviceAccept.item : this.serviceCancel.item
                
                const payload = {
                    id: item._id || item.id
                }
                
                if (action === 'accept') {
                    this.serviceAccept.loading = true
                    
                    const hasDiscount = parseFloat(item.serviceDiscount) > 0
                    
                    if (hasDiscount) {
                        payload.discount = parseFloat(item.serviceDiscount)
                    }
                    
                    let observation = hasDiscount 
                        ? ``
                        : 'Nenhum desconto concedido.'
                    
                    if (this.serviceAccept.observation) {
                        observation += ` ${this.serviceAccept.observation}`
                    }
                    
                    payload.observation = observation
                    
                } else {
                    this.serviceCancel.loading = true
                    
                    payload.status = 13
                    payload.observation = this.serviceCancel.reason
                }
                
                this.$axios.put(`/portal/request/ssu/quotation/${item.orderSyncId}`, payload)
                    .then((response) => {
                        if (action === 'accept') {
                            this.serviceAccept.loading = false
                            this.serviceAccept.show = false
                            showSuccess('Serviço aprovado com sucesso!')
                        } else {
                            this.serviceCancel.loading = false
                            this.serviceCancel.show = false
                            showInfo('Serviço cancelado com sucesso!')
                        }
                        this.load()
                    })
                    .catch((err) => {
                        if (action === 'accept') {
                            this.serviceAccept.loading = false
                        } else {
                            this.serviceCancel.loading = false
                        }
                        showError('Erro ao processar serviço. Tente novamente.')
                    })
            },
            showSuccessBanner() {
                this.successBanner.pending = true
            },
            load() {
                this.loading = true
                this.orders = []
                this.$axios(`/portal/order/${this.$route.params.gridId}?ignoreProfile=1&quotation=1&pp=100`).then((response) => {
                    const data = response.data.data
                    const ordersList = Array.isArray(data) ? data : (data.orders || [])
                    const orderVOItems = (!Array.isArray(data) && data.gridOverview && data.gridOverview.orderVOItems) || {}
                    const syncIdsRaw = (!Array.isArray(data) && data.gridOverview && data.gridOverview.syncIds) || []
                    const syncIdsMap = {}
                    syncIdsRaw.forEach(s => { syncIdsMap[s.syncId] = s })
                    const orders = []
                    let isFirst = false
                    ordersList.forEach((order) => {
                        if (order.gri_version == order.gridVersion && !isFirst) {
                            isFirst = true
                            order.first = true
                        }
                        else {
                            order.first = false
                        }
                        order.show = false
                        order.itemType = 'formato' 

                        if (order.gri_version == order.gridVersion) {
                            orders.push(order)

                            
                            const matchingSsuOrders = this.getMatchingSsuOrders(order)
                            matchingSsuOrders.forEach((ssuOrder) => {
                                const initialDiscount = (ssuOrder.discount && parseFloat(ssuOrder.discount) > 0) ? parseFloat(ssuOrder.discount) : 0
                                const discountAmount = (ssuOrder.netUnitPrice || 0) * (initialDiscount / 100)
                                
                                const serviceItem = {
                                    ...ssuOrder,
                                    itemType: 'servico',
                                    show: false,
                                    first: false,
                                    
                                    gridVersion: order.gridVersion,
                                    gri_version: order.gri_version,
                                    orderGridId: order.orderGridId,
                                    users: order.users,
                                    executive_s: order.executive_s,
                                    pro_displayname: order.pro_displayname,
                                    pro_name: order.pro_name,
                                    pro_document: order.pro_document,
                                    expired: order.expired,
                                    
                                    parentFormat: {
                                        uri: order.uri,
                                        format: order.asuFormat?.sort?.format,
                                        display_name: order.asuFormat?.display_name
                                    },
                                    
                                    dates: ssuOrder.dates || [],
                                    
                                    serviceInvert: false,
                                    serviceDiscount: initialDiscount.toString(),
                                    serviceFixedValue: discountAmount.toFixed(2),
                                    serviceFinalPrice: (ssuOrder.netUnitPrice || 0) - discountAmount
                                }
                                orders.push(serviceItem)
                            })
                        }
                    })
                    orders.forEach((order) => {
                        if (order.itemType !== 'formato') return
                        const syncEntry = syncIdsMap[order.orderSyncId]
                        if (syncEntry) {
                            order.syncQuantity = syncEntry.quantity != null ? Number(syncEntry.quantity) : null
                            order.syncInsertions = syncEntry.insertions != null ? Number(syncEntry.insertions) : null
                        }
                        const orderIds = (order.ord_ids || '').split(',').filter(Boolean)
                        const voItems = orderIds.map(id => orderVOItems[id]).filter(Boolean)
                        if (voItems.length) {
                            const sum = (key) => voItems.reduce((acc, vo) => acc + (Number(vo[key]) || 0), 0)
                            order.totalPrice = sum('totalPrice')
                            order.finalPrice = sum('finalPrice')
                            order.fractionalQuantity = sum('fractionalQuantity')
                            order.insertions = sum('insertions')

                            const audits = voItems.reduce((acc, vo) => {
                                const list = Array.isArray(vo.priceTableAudit) ? vo.priceTableAudit : Object.values(vo.priceTableAudit || {})
                                return acc.concat(list)
                            }, [])
                            if (audits.length) {
                                const latest = audits.reduce((newest, a) =>
                                    moment(a.createdOn).isAfter(moment(newest.createdOn)) ? a : newest
                                )
                                if (latest && latest.priceTable != null) {
                                    const newPriceTable = Number(latest.priceTable) / 100
                                    order.newPriceTable = newPriceTable

                                    const pricing = order.asuFormat && order.asuFormat.asus && order.asuFormat.asus.private_pricing_info
                                    const oldUnit = pricing ? (Number(pricing.markup) || 1) * (Number(pricing.unity_price) || 0) : 0
                                    if (oldUnit > 0) {
                                        const ratio = newPriceTable / oldUnit
                                        order.totalPrice = order.totalPrice * ratio
                                        order.finalPrice = order.finalPrice * ratio
                                    }
                                }
                            }
                        }
                    })

                    this.orders = orders

                    if (this.successBanner.pending) {
                        const hasPendingItems = orders.some(o => o.itemType === 'formato' && (o.orderStatusId == 15 || o.orderStatusId == '15'))
                        if (!hasPendingItems) {
                            this.successBanner.fullName = this.$root.auth?.user?.name || ''
                            this.successBanner.show = true
                        }
                        this.successBanner.pending = false
                    }

                    this.loading = false
                })
            },
            getStatusText(item) {
                const statusId = item.status || item.orderStatusId
                // Se está expirado e o status está entre 14-24, mostra mensagem de cancelamento
                if (item.expired === true && statusId >= 14 && statusId <= 24) {
                    return 'Cancelada por falta de resposta'
                }
                return helper.getStatusText(statusId)
            },
            getStatusColor(item) {
                const statusId = item.status || item.orderStatusId
                // Se está expirado e o status está entre 14-24, retorna vermelho
                if (item.expired === true && statusId >= 14 && statusId <= 24) {
                    return '#dc3545'
                }
                return helper.getStatusColor(statusId)
            },
            formatServiceDate(dateStr) {
                if (!dateStr) return 'N/D'
                return moment(dateStr).format('DD/MM/YYYY')
            },
            getLastQuotationStatus(item, key) {
                
                if (item.itemType === 'servico') {
                    
                    if (parseInt(item.status) === 18 && item.track && item.track.length) {
                        const lastTrack = item.track[item.track.length - 1]
                        
                        if (key === 'quotation') {
                            
                            return '-'
                        }

                        if (key === 'date' && lastTrack.updatedOn) {
                            return moment(lastTrack.updatedOn.$date.$numberLong ? parseInt(lastTrack.updatedOn.$date.$numberLong) : lastTrack.updatedOn).locale('pt-br').format('DD [de] MMMM [de] YYYY HH:mm')
                        }

                        if (key === 'email' && lastTrack.updatedBy) {
                            
                            const user = item.users ? item.users.find(u => u.id === lastTrack.updatedBy) : null
                            return user ? user.email : '-'
                        }
                    }
                    
                    return '-'
                }
                
                if (parseInt(item.orderStatusId) === 18) {
                    const allFlows = item.lastQuotation && item.lastQuotation.flow && item.lastQuotation.flow.length
                        ? item.lastQuotation.flow
                        : []
                    const publisherFlow = allFlows.find(f => !['created', 'add_quotation'].includes(f.action))
                    const flow = allFlows[0] || null

                    if (!flow) return '-'

                    if (key === 'quotation') {
                        if (publisherFlow && publisherFlow.values && publisherFlow.values.value !== undefined) {
                            return `${this.$n(publisherFlow.values.value)}%`
                        }
                        const totalPrice = parseFloat(item.totalPrice) || 0
                        const finalPrice = parseFloat(item.finalPrice) || 0
                        if (totalPrice > 0 && finalPrice > 0 && finalPrice < totalPrice) {
                            return `${this.$n(Math.round((1 - finalPrice / totalPrice) * 10000) / 100)}%`
                        }
                        return '-'
                    }

                    if (key === 'date' && flow.createdOn) {
                        return moment(flow.createdOn).locale('pt-br').format('DD [de] MMMM [de] YYYY HH:mm')
                    }

                    if (key === 'email' && flow.user && flow.user.email) {
                        return flow.user.email
                    }
                }

                
                let k = 0

                const flow = item.lastQuotation && item.lastQuotation.flow.length ? item.lastQuotation.flow[k] : { action: "", user: null, createdOn: null }
                if (key == 'user' && flow.user && flow.user.name && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action))
                    return flow.user.name
                if (key == 'email' && flow.user && flow.user.email && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action))
                    return flow.user.email
                if (key == 'date' && flow.createdOn && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action))
                    return moment(flow.createdOn).format('DD/MM/YYYY HH:mm')
                if (key == 'action' && flow.action)
                    return flow.action

            if (key == 'quotation' && flow.values && Object.keys(flow.values).length && !['created', 'add_quotation'].includes(item.lastQuotation.flow[k].action)) {
                return `${this.$n(flow.values.value)} ${flow.values.type == 'percent' ? '%' : ''}`
            }
            return '-'
        }
    }
}
</script><style lang="scss">
.quotation-regular {
    padding: 10px 15px;
    width: 100%;

    table {

        td,
        th {
            padding: 5px;
            font-size: 0.83em;
        }
    }
}

.grid-row-template {
    display: grid;
    align-items: center;
    grid-template-columns: 50px 200px 1fr 1fr 90px 1fr 1fr;
    column-gap: 5px;

    &>*:first-child {
        margin-left: 5px;
    }

    &>*:last-child {
        margin-right: 5px;
    }
}

.order-row-template {
    display: grid;
    align-items: center;
    grid-template-columns: 50px 2fr 1fr 1fr 1fr 1fr 50px;
    column-gap: 5px;

    &>*:first-child {
        margin-left: 5px;
    }

    &>*:last-child {
        margin-right: 5px;
    }
}

.calendar-table {
    width: 1280px;
    display: inline-block;
    border-collapse: collapse;

    th,
    td {
        border-left: 1px solid #d0d0d0;
        height: 28px;

    }

    tbody tr:nth-child(odd) {

        td,
        th {
            background: #dadada;
        }

        th {
            width: 130px;
        }
    }

    tbody tr:nth-child(even) {

        td,
        th {
            background: #fff;
        }

        th {
            width: 130px;
        }
    }

    th:not(:first-child),
    td:not(:first-child) {
        width: 40px;
    }

    th {

        color: #353535;
        font-weight: bold;
        font-size: 10px;
    }

    td {
        font-size: 12px;
    }

    tr>*:first-child {
        border: none;
        position: sticky;
        left: 0;
        z-index: 2;
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, .2);

        /* keep above other cells */
    }

}
.success-banner-dialog {
    box-shadow: none !important;
}

.success-banner-title {
    font-size: 20px;
    font-weight: 700;
    color: #04195d;
    margin-bottom: 20px;
}

.success-banner-text {
    font-size: 15px;
    line-height: 1.5;
    margin-bottom: 14px;
    color: #fff;
}

.success-banner-highlight {
    color: #04195d;
    font-weight: 700;
}

.success-banner-buttons {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}
</style>